import { observer } from "mobx-react";
import classNames from "classnames";
import styles from "./styles/HeroContainer.module.scss";
import FontAwesome from "../utilities/FontAwesome";
import { MobileSchoolsDropdown, SchoolsDropdown } from "./SchoolsDropdown";
import { useHeroTerrace } from "../../hooks/useHeroTerrace";
import { HeroMediaElement } from "./HeroMediaElement";
import LogoAndTitle from "./LogoAndTitle";
import { useStores } from "../../stores/useStores";
import { useTranslateClassName } from "../../hooks/useTranslateClassName";
import { Button } from "@radix-ui/themes";
import { useSecondaryNavIsSticky } from "./NavigationSecondary";

const HeroContainer = observer(
  (props: {
    displayViewHomepageButton: boolean;
    isWelcomePage: boolean;
    secondaryNavHeight: number;
  }) => {
    const { userStore, modalStore, styleStore } = useStores();

    const heroBlock = useHeroTerrace();
    const translateClassName = useTranslateClassName();
    const stickyNavigation = useSecondaryNavIsSticky();
    const showSchoolsDropdown = heroBlock && !props.isWelcomePage;

    function openEditHeroModal() {
      modalStore.addModal({
        type: "edit-hero",
        id: "edit-hero",
      });
    }

    const containerClassName = classNames({
      [styles.container]: true,
      [styles.containerNonStickyNavigation]: !stickyNavigation,
      [styles.containerIsWelcomePage]: props.isWelcomePage,
      [styles.containerFloatingBlocksTheme]: styleStore.themeID === "2",
    });

    return (
      <div className={translateClassName}>
        <div
          className={containerClassName}
          id={"hero"}
          style={{ height: props.isWelcomePage ? "100vh" : undefined }}
        >
          <HeroMediaElement isWelcomePage={props.isWelcomePage} />
          <LogoAndTitle
            displayViewHomepageButton={props.displayViewHomepageButton}
            isWelcomePage={props.isWelcomePage}
            logoClassName={styles.logo}
            titleClassName={styles.title}
          />
          {userStore.isEditor && (
            <Button
              size="3"
              highContrast
              radius="full"
              className={styles.editHeroButton}
              onClick={openEditHeroModal}
            >
              <FontAwesome prefix={"fas"} name={"fa-image"} />
              Edit Hero
            </Button>
          )}
          {showSchoolsDropdown && (
            <div className={styles.desktopDropDownContainer}>
              <SchoolsDropdown heroBlock={heroBlock} />
            </div>
          )}
        </div>
        {showSchoolsDropdown && (
          <div className={styles.mobileDropDownContainer}>
            <MobileSchoolsDropdown heroBlock={heroBlock} />
          </div>
        )}
      </div>
    );
  },
);

export default HeroContainer;
